import { render, staticRenderFns } from "./dataAnalysisTemplate.vue?vue&type=template&id=28450e19&scoped=true"
import script from "./dataAnalysisTemplate.vue?vue&type=script&lang=js"
export * from "./dataAnalysisTemplate.vue?vue&type=script&lang=js"
import style0 from "./dataAnalysisTemplate.vue?vue&type=style&index=0&id=28450e19&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28450e19",
  null
  
)

export default component.exports